import {get, post} from '../api/http'

export default{
    //获取用户信息
    getUserInfo(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/user/info', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取用户详细信息
    getUserDetail(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/user/detail', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取店铺信息
    getShopInfo(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/shop/info', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取店铺联系人
    getShopContact(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/shop/contact', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取轮播图接口
    getSlideShow(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/system/getSlideShow', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取常量接口
    getListConstant(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/system/getListConstant', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //新增访问记录
    visitLog(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/shop/visitlog', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取商铺商品列表信息
    getListProMsg(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/listShopPro', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取商品详情
    getProDetail(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/detail', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //创建预付订单
    createOrderPre(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/order/createPre', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取小程序二维码
    getQrCode(params){
        return new Promise((resolve, reject) => {
            post('/fastapi/v1/wx/qrUrl', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },


    //查询预付订单
    getPreOrderMsg(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/order/getPre', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //商品详情
    detail(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/detail', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取免费试看视频
    freeVideo(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/video/freeVideo', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取章节列表
    listLesson(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/course/listLesson', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //通过章节获取目录列表
    listCatalogue(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/course/listCatalogue', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //创建订单
    createOrderByPre(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/order/createByPre', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //base64
    getImgBase64(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/system/getImgBase64', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //获取片头片尾
    prelude(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/video/prelude', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    //分享赚钱
    income(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/income', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    //获取海报
    getPoster(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/poster/get', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    // 查询商品有无视频，返回相应信息
    getCourseDetailsSwiperVideo(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/productVideoOrImage', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    // 获取店铺页面的商品分类
    getShopClassification(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/listShopProByGroup', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    // 获取店铺页面的商品分组
    getShopCategoryList(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v1/product/getCategoryList', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    // 极速v2.0
    // 提交订单
    submitOfflineOrder(params){
        return new Promise((resolve, reject) => {
            get('/fastapi/v2/order/create', params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
}